import { PlusOutlined } from "@ant-design/icons";
import { useQuery } from "@tanstack/react-query";
import { Button, Card, List, Space, Typography } from "antd";
import { useState } from "react";
import { useNavigate } from "react-router";
import { api, unwrap } from "@/api/client";
import { useAuth } from "@/auth/AuthProvider";
import { useI18n } from "@/i18n";
import { CaseKindTag, CaseStatusTag, CreateCaseModal, type OrderForCase } from "./common";

/** Detail order > Purna jual: the order's cases, and opening a new one. */
export function OrderCases({ order }: { order: OrderForCase }) {
  const { t, formatDateTime } = useI18n();
  const { me, can } = useAuth();
  const navigate = useNavigate();
  const tz = me?.workspace?.timezone;
  const [creating, setCreating] = useState(false);
  const q = useQuery({
    queryKey: ["aftersales", "order", order.id],
    queryFn: () => unwrap(api.GET("/v1/aftersales", { params: { query: { orderId: order.id } } })),
  });
  const items = q.data?.items ?? [];
  return (
    <Card
      size="small"
      title={t("as.orderCard")}
      extra={
        can("orders.manage") && (
          <Button size="small" icon={<PlusOutlined />} onClick={() => setCreating(true)}>
            {t("as.add")}
          </Button>
        )
      }
    >
      <List
        size="small"
        loading={q.isPending}
        dataSource={items}
        locale={{ emptyText: t("as.orderCardEmpty") }}
        renderItem={(x) => (
          <List.Item style={{ cursor: "pointer", paddingInline: 0 }} onClick={() => navigate(`/app/aftersales/${x.id}`)}>
            <Space orientation="vertical" size={2}>
              <Space size={6} wrap>
                <Typography.Text strong className="z-num">
                  {x.number}
                </Typography.Text>
                <CaseKindTag kind={x.kind} />
                <CaseStatusTag status={x.status} />
              </Space>
              <Typography.Text type="secondary" style={{ fontSize: 12 }}>
                {formatDateTime(x.createdAt, tz)}
                {x.returnTrackingNo ? ` · ${t("as.returnTracking")} ${x.returnTrackingNo}` : ""}
              </Typography.Text>
            </Space>
          </List.Item>
        )}
      />
      <CreateCaseModal order={creating ? order : null} onClose={() => setCreating(false)} onCreated={(c) => (setCreating(false), navigate(`/app/aftersales/${c.id}`))} />
    </Card>
  );
}
